import { createStyles, Theme } from '@material-ui/core';

export default (theme: Theme) => createStyles({
  root: {
    '&.Mui-checked, &.MuiCheckbox-indeterminate': {
      color: `${theme.appPalette.orange}`,
    },
  },
});
